<template lang="pug">
.content(v-loading="isLoading")
  el-tabs.tabs(v-if="user" v-model="active")
    el-tab-pane(:label="$t('UserInfo.title07')" name="contract")
      section.contracted_cuona
        h2 {{ $t('UserInfo.title01') }}
        el-row
          el-col(:span="12")
            img.cube(:src='images.cube')
            div.space
              p.counter
                span.title {{ $t('UserInfo.contract_num')}}
                span.count {{ company.num_cube_devices }}
          el-col(:span="12")
            img.tag(:src='images.tag')
            div.space
              p.counter
                span.title {{ $t('UserInfo.contract_num')}}
                span.count {{company.num_tag_devices}}

      //- プラグイン一覧
      section.contracted_plugins
        h2 {{ $t('UserInfo.pluginList') }}
        plugins(:plugins.sync="plugins")

    el-tab-pane(:label="$t('UserInfo.title08')" name="info")
      section.info
        h2 {{ $t('UserInfo.title03') }}
          el-button(v-if="user.role !== 'manager'" size="mini" icon="el-icon-edit" @click="openUserEditDialog") {{ $t('UserInfo.editButton') }}
        h3 {{ $t('UserInfo.title04') }}
        el-row
          el-col
            p
              span.name {{ company.name }}
              span.kana {{ company.name_kana }}
            p
              span.address {{ company.address }}
              span.phone {{ company.phone_number }}
              span.fax {{ company.fax_number }}
        h3 {{ $t('UserInfo.title05') }}
        el-row
          el-col
            p
              span.name {{ user.name }}
              span.kana {{ user.name_kana }}
              span.email {{ user.email }}
        template(v-if="user.notes !== null")
          h3 {{ $t('UserInfo.note') }}
          el-row
            el-col
              p.note(v-html='nl2br(user.notes)')
        h3 {{ $t('UserInfo.sdkToken') }}
        el-row
          el-col
            p
              span.sdk {{ company.sdk_token }}
              el-tooltip(placement="top" :content="$t('UserInfo.copySdkTokenTooltip')")
                a(@click="copySDKToken(company.sdk_token)")
                  i.el-icon-copy-document
              el-dropdown(size="small" placement="bottom-start")
                el-button(type="text" icon="el-icon-more")
                el-dropdown-menu(slot="dropdown")
                  el-dropdown-item
                    a(@click="isShowingResetDialog=true") {{ $t('UserInfo.resetSdkTokenButton') }}

    el-dialog(:title="$t('UserInfo.resetSdkTokenWindowTitle')" class="resetTokenDialog" :visible.sync="isShowingResetDialog")
      p.message(v-html="$t('UserInfo.resetSdkTokenDescription')")
      el-input(v-model="checkReset" :placeholder="$t('UserInfo.checkSdkTokenResetWord')")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingResetDialog=false") {{ $t('UserInfo.cancelButton') }}
        el-button(type="danger" @click="resetSdkToken" :disabled="checkWord()") {{ $t('UserInfo.doReset') }}

    //- 編集ダイアログ
    el-dialog.edit-user-dialog(:title="$t('UserInfo.title06')" :visible.sync="isShowingUserEditDialog")
      el-form(label-position="left" :rules="rules" label-width="160px" ref="userEditDialogForm" :model="userEditDialogForm" v-loading="isLoading")
        el-form-item(:label="$t('UserInfo.staff_name')" prop="name")
          el-input(v-model="userEditDialogForm.name")
        el-form-item(:label="$t('UserInfo.staff_name_furi')" prop="name_kana" v-if="$i18n.locale === 'ja'")
          el-input(v-model="userEditDialogForm.name_kana")
        el-form-item(:label="$t('UserInfo.email')" prop="email")
          el-input(v-model="userEditDialogForm.email")
        el-form-item(:label="$t('UserInfo.note')")
          el-input(type="textarea" :rows="3" v-model="userEditDialogForm.notes")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingUserEditDialog = false" :disabled="isLoading") {{$t('UserInfo.cancelButton')}}
        el-button(type="primary" @click="updateUser" :loading="isLoading" :disabled="isLoading") {{$t('UserInfo.sendButton')}}
</template>

<script>
import Plugins from './Plugins'
import UserApi from '@/api/user'
import CompanyApi from '@/api/companies'
import PluginApi from '@/api/plugin'
export default {
  components: { Plugins },
  data () {
    return {
      active: "contract",
      user: null,
      isLoading: false,
      isShowingUserEditDialog: false,
      isShowingResetDialog: false,
      checkReset: "",
      plugins: [],
      userEditDialogForm: {
        name: '',
        name_kana: '',
        email: '',
        notes: ''
      },
      rules: {
        name: [
          { required: true, message: '担当者名を入力して下さい', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'メールアドレスを入力して下さい', trigger: 'blur' }
        ]
      },
      images:{
        cube: require('@/assets/cuona_cube.png'),
        tag: require('@/assets/cuona_tag.svg'),
        cuona: require('@/assets/cuona_small_logo.svg'),
      },
    }
  },
  mounted() {
    this.getUser();
    this.getPlugins();
  },
  computed: {
    company: function() {
      return this.user.company;
    },
  },
  title() {
    return this.$t('submenus.contract')
  },
  methods: {
    getUser() {
      this.isLoading = true;
      UserApi.getUser()
        .then((user) => {
          this.user = user;
          this.isShowingUserEditDialog = false;
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('user.failed_get'),
            type: 'error'
          });
        }).finally(() => { this.isLoading = false; });
    },

    copySDKToken: function(token) {
      let temp = document.createElement('textarea')
      temp.value = token
      temp.selectionStart = 0
      temp.selectionEnd = temp.value.length

      var s = temp.style
      s.position = 'fixed'
      s.left = '-100%'

      document.body.appendChild(temp)
      temp.focus()
      let result = document.execCommand('copy')
      temp.blur()
      document.body.removeChild(temp)

      if (result) {
        this.$message({
          showClose: true,
          message: this.$t('Clipboard.copySuccessful'),
          type: 'success'
        })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('Clipboard.copyFailed'),
          type: 'error'
        })
      }
    },

    checkWord: function()
    {
      return (this.checkReset === this.$t('UserInfo.checkSdkTokenResetWord')) ? false : true;
    },

    // ユーザー編集ダイアログを開く
    openUserEditDialog: function() {
      this.userEditDialogForm.name = this.user.name
      this.userEditDialogForm.name_kana = this.user.name_kana
      this.userEditDialogForm.email = this.user.email
      this.userEditDialogForm.notes = this.user.notes
      this.isShowingUserEditDialog = true
    },

    // ユーザー情報の更新
    updateUser: function() {
      this.$refs['userEditDialogForm'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const params = {
            name: this.userEditDialogForm.name,
            name_kana: this.userEditDialogForm.name_kana,
            email: this.userEditDialogForm.email,
            notes: this.userEditDialogForm.notes
          }
          UserApi.updateUser(params)
            .then((user) => {
              this.user = user;
              this.$store.commit('setUser', user);
              this.isShowingUserEditDialog = false;
              this.$message({
                showClose: true,
                message: this.$t('user.success_update'),
                type: 'success'
              });
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: this.$t('user.failed_update'),
                type: 'error'
              });
            }).finally(() => {
              this.isLoading = false;
            });
        } else {
          return false;
        }
      });
    },

    getPlugins() {
      PluginApi.getPlugins().then(plugins => {
        this.plugins = plugins;
      }).catch(error => {
        console.error(error);
        this.$message.error(this.$t('user.loading_error'));
      });
    },

    resetSdkToken() {
      this.isShowingResetDialog = false;
      this.checkReset = "";
      const that = this;
      CompanyApi.resetSdkToken().then(function() {
        that.getUser();
      }).catch(function() {
        that.$message({
          showClose: true,
          message: that.$t('UserInfo.failedToResetSdkToken'),
          type: 'error'
        });
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

.content {
  padding: 20px 0;
  min-height: 20vh;

  .tabs ::v-deep {
    .el-tabs__nav-scroll {
      padding: 0 40px;
    }
    .el-tabs__nav-wrap:after {
      height: 1px;
    }
    .el-tabs__header {
      margin: 0 0 40px;
    }
  }

  section {
    margin: 0 0 20px 0;
    padding-bottom: 40px;

    h2 {
      font-size: 16px;
      font-weight: normal;
      color: #333;
      margin: 0;
    }

    h3 {
      font-size: 15px;
      background: rgba(0,0,0,0.05);
      padding: 10px 40px;
    }
  }

  section.contracted_cuona {
    padding: 0 40px 20px 40px;

    .el-row {
      display: flex;
      align-content: flex-start;

      .el-col {
        border-radius: 6px;
        border:1px solid $border;
        padding: 20px;
        text-align: center;
        margin-right: 20px;

        &:last-child{
          margin-right: 0;
        }

        img.cube, img.tag {
          height: 80px;
          margin-bottom: 10px;
        }

        p.counter {
          display: inline-block;
          margin: 5px auto;
          font-size: 12px;
          border: 1px solid $border;
          border-radius: 20px;

          span.title {
            display: inline-block;
            max-width: 80px;
            width: 40px;
            background: $border;
            padding: 4px 10px 5px 15px;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          span.count {
            display: inline-block;
            min-width: 40px;
            padding: 5px 15px 5px 10px;
            margin: 0 auto;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          }
        }
      }
    }
  }
  section.contracted_plugins {
    padding: 0 40px 20px 40px;
  }

  section.info {
    padding: 0;
    margin-bottom: 0;
    border: none;

    h2 {
      margin-left: 40px;

      button {
        margin: 0 0 0 20px;
      }
    }

    h3 {
      font-weight: normal;
    }

    .el-row {
      margin: 0;
      padding: 0 0 0 30px;

      .el-col {
        p {
          margin:0 0 0 10px;
          span {
            font-size: 14px;
            &.kana { display: none; }
            &.address { display: block; }
            &.phone { display: block; }
            &.email { display: block; }
            &.sdk { margin-right: 5px; }
          }
          .el-tooltip {
            cursor: pointer;
          }
          .el-dropdown {
            margin-left: 5px;
            height: 24px;
          }

          &.note {
            font-size: 14px;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  p.message ::v-deep {
    margin: 0 0 20px 0;

    strong {
      margin: 0 5px;
      font-style: italic;
    }
  }

  .edit-user-dialog ::v-deep {
    .el-dialog {
      padding: 20px;

      .el-dialog__header {
        padding:10px 0 20px 20px;
      }
    }
  }

  .el-row {
    padding: 15px 0;

    &:first-child {
      padding-top:0;
    }
    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    .border {
      border-bottom: 1px solid $border;
    }
  }
}
</style>
